import { render } from "./TypesciptSync.vue?vue&type=template&id=69addecb&scoped=true&ts=true"
import script from "./TypesciptSync.vue?vue&type=script&lang=ts"
export * from "./TypesciptSync.vue?vue&type=script&lang=ts"

import "./TypesciptSync.vue?vue&type=style&index=0&id=69addecb&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69addecb"]])

export default __exports__